import { render } from "./FormChangeHoliday.vue?vue&type=template&id=39e19973"
import script from "./FormChangeHoliday.vue?vue&type=script&lang=js"
export * from "./FormChangeHoliday.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__